import { BarcodeChar, BarcodeTypes, LabelSize } from './types';

export const getHostname = () => {
  const parts = location.hostname.split('.');
  if (parts.length === 3) {
    parts.shift();
  }
  let hostname = parts.join('.');
  if (hostname === 'localhost') {
    hostname = 'rad.localdev';
  }
  return hostname;
};

// From a given code and format, return the code without the checksum number as ZPL will automatically add it when printing labels
// Also forces the systemSKu as an ean8 format if printing on small and jewelry labels due to the restricted space
export const getCode = (
  rawCode: string,
  type: BarcodeTypes,
  size: LabelSize
): { code: string; char: BarcodeChar } => {
  const code = String(rawCode).replace(/[^0-9]/g, '');
  let returnedCode = code;
  let char: BarcodeChar = 'C';

  if ((type === 'ean' || type === 'systemSku') && [7, 8, 12, 13].includes(code.length)) {
    char = 'E';
    // EAN-13
    if (code.length === 13) {
      const codeParts = splitAt(code, 12);
      if (getCheckDigit(codeParts[0]) === codeParts[1]) {
        [returnedCode] = codeParts;
      }
    }

    // EAN-8
    if ((size === 'jewelry' || size === 'small') && (type === 'ean' || type === 'systemSku')) {
      char = '8';
      returnedCode = returnedCode.slice(-7);
    }

    return { code: returnedCode, char };
  }
  if (type === 'upc' && [11, 12].includes(code.length)) {
    char = 'U';
    // UPC-A
    if (code.length === 12) {
      const codeParts = splitAt(code, 11);
      if (getCheckDigit(codeParts[0]) === codeParts[1]) {
        [returnedCode] = codeParts;
      }
    }
  }

  return { code: returnedCode, char };
};

export const getCheckDigit = (rawCode: string): string => {
  const code = String(rawCode).replace(/[^0-9]/g, '');

  let sum = 0;
  let odd = 1;
  for (let i = code.length - 1; i > -1; i -= 1) {
    sum += Number(code[i]) * (odd % 2 === 0 ? 1 : 3);
    odd += 1;
  }

  return String(10 - (sum % 10)).slice(-1);
};

export const splitAt = (string: string, index: number): [string, string] => [
  string.slice(0, index),
  string.slice(index),
];
